<div class="slider-container" [class.slider-checked]="value" [class.slider-disabled]="disabled" (click)="onClickSlider()">
  <span class="slider-ball"></span>
</div>
